export const pagination = {
    current_page: 0,
    limit: null,
    pages: null,
    max_count: null,
    next_page: null
};
